<i18n>
  {
    "en": {
      "PortfolioSelection": "Portfolio selection",
      "OlgaBushkovaPhotography": "Olga Bushkova. 360° Tours",

      "accounting": "accounting facilities",
      "airport": "airports",
      "amusement_park": "Amusement parks",
      "aquarium": "aquariums",
      "art_gallery": "art galleries",
      "atm": "ATMs",
      "bakery": "bakeries",
      "bank": "banks",
      "bar": "bars",
      "beauty_salon": "beauty salons",
      "bicycle_store": "bicycle stores",
      "book_store": "book stores",
      "bowling_alley": "bowling alleys",
      "bus_station": "bus stations",
      "cafe": "cafes",
      "campground": "campgrounds",
      "car_dealer": "car dealerships",
      "car_rental": "car rentals",
      "car_repair": "car repair shops",
      "car_wash": "car washes",
      "casino": "casinos",
      "cemetery": "cemeteries",
      "church": "churches",
      "city_hall": "city halls",
      "clothing_store": "clothing stores",
      "convenience_store": "convenience stores",
      "courthouse": "courthouses",
      "dentist": "dentists",
      "department_store": "department stores",
      "doctor": "doctors",
      "electrician": "electricians",
      "electronics_store": "electronics stores",
      "embassy": "embassies",
      "fire_station": "fire stations",
      "florist": "florists",
      "funeral_home": "funeral homes",
      "furniture_store": "furniture stores",
      "gas_station": "gas stations",
      "gym": "gyms",
      "hair_care": "hair care shops",
      "hardware_store": "hardware stores",
      "hindu_temple": "hindu temples",
      "home_goods_store": "home goods stores",
      "hospital": "hospitals",
      "insurance_agency": "insurance agencies",
      "jewelry_store": "jewelry stores",
      "laundry": "laundries",
      "lawyer": "lawyers",
      "library": "libraries",
      "liquor_store": "liquor stores",
      "local_government_office": "local government offices",
      "locksmith": "locksmiths",
      "lodging": "lodgings",
      "meal_delivery": "meal deliveries",
      "meal_takeaway": "meal takeaways",
      "mosque": "mosques",
      "movie_rental": "movie rentals",
      "movie_theater": "movie theatres",
      "moving_company": "moving companies",
      "museum": "museums",
      "night_club": "night clubs",
      "painter": "painters",
      "park": "parks",
      "parking": "parkings",
      "pet_store": "pet stores",
      "pharmacy": "pharmacies",
      "physiotherapist": "physiotherapists",
      "plumber": "plumbers",
      "police": "police stations",
      "post_office": "post offices",
      "real_estate_agency": "real estate agencies",
      "restaurant": "restaurants",
      "roofing_contractor": "roofing contractors",
      "rv_park": "RV parks",
      "school": "schools",
      "shoe_store": "shoe stores",
      "shopping_mall": "shopping malls",
      "spa": "spas",
      "stadium": "stadiums",
      "storage": "storages",
      "store": "stores",
      "subway_station": "subway stations",
      "supermarket": "supermarkets",
      "synagogue": "synagogues",
      "taxi_stand": "taxi stands",
      "train_station": "train stations",
      "transit_station": "transit stations",
      "travel_agency": "travel agencies",
      "veterinary_care": "veterinary cares",
      "zoo": "zoos"
    }
  }
</i18n>
<template>
  <div class="work-selection">
    <div class="top-bar">
      <router-link :to="{name: 'home'}"><h1>{{ $t("OlgaBushkovaPhotography") }}</h1></router-link>

      <global-menu></global-menu>
    </div>

    <div class="container">
      <div class="portfolio-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
        <h1 class="display-4">{{$t('PortfolioSelection')}} (<span v-for="(tag, index) in tags" :key="tag">{{ $t(tag) + (index === tags.length - 1 ? '' : ', ')}}</span>)</h1>
      </div>
    </div>

    <div class="container mb-5">
      <div class="row">
        <div class="col-md-6 col-lg-4" v-for="(work, index) in works" :key="work.id">
          <div
            :class="{'card': true, 'mb-4': true, 'box-shadow': true, 'd-none d-sm-block': index >= 6}"
          >
            <router-link :to="{name: 'work-preview', params: { id: work.id}}">
              <img
                class="card-img-top d-block"
                alt="Thumbnail"
                :src="work.previewImageURL"
                data-holder-rendered="true"
              >
            </router-link>
            <div class="card-body">
              <p class="card-text">{{ work.title }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>    
  </div>
</template>
<style lang="scss" scoped>
@import '../bootstrap-overrides';
@import '~bootstrap/scss/_functions';
@import '~bootstrap/scss/_variables';
@import '~bootstrap/scss/mixins/_breakpoints';

.top-bar {
  background-color: black;
  height: 5.5em;

  h1 {
    color: #e0e0e0;
    text-align: center;
    padding-top: 1em;
    font-size: 1.7em;
  }

  @include media-breakpoint-down(md) {
    h1 {
      display: none;
    }
  }
}

@include media-breakpoint-down(md) {
  h1 {
    font-size: 250%;
  }
}

img.card-img-top {
  /* TODO: this is a hack. Rely on flex to ensure equal height. */
  min-height: 100px;
}


</style>
<script>
import GlobalMenu from './Home/GlobalMenu.vue';

import UserApi from '@/user-api';

export default {
  name: 'home',
  components: {
    GlobalMenu
  },
  beforeRouteEnter(to, from, next) {
    const tags = to.params.tags.split(',').filter(t => UserApi.PLACE_TYPES.indexOf(t) !== -1);
    tags.sort((a, b) => a.localeCompare(b));
    UserApi.getWorksByPlaceTypes(tags).then(works => {
      next(vm => {
        vm.tags = tags;
        vm.works = works;
      });
    });
  },
  data() {
    return {
      tags: [],
      works: [],
    };
  }
};

</script>